<template>
<div>
  <div>
      <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
        <span>{{message}}</span>
      </v-snackbar>
      <v-card class="neu-glow pb-3">
        <v-card-title primary-title>
          <div class="text-h5">Eccezioni ai Parametri Standard</div>
          <v-spacer></v-spacer>
          <v-div class="mr-n5">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" :disabled="activeExceptions_hash==JSON.stringify(activeExceptions)" @click.stop="editItems()">
                  <v-icon color="error">mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.stop="addItem(null)">
                  <v-icon color="info">mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <span>Aggiungi</span>
            </v-tooltip>            
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>                
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData()">
                  <v-icon color="info">mdi-sync-circle</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>                                     
          </v-div> 
        </v-card-title>
        <v-row v-if="loading" class="pb-3 pl-3">
            <v-col class="text-center">
              <v-progress-linear
                color="info"
                height="10"
                indeterminate
                striped
              ></v-progress-linear>
            </v-col>
        </v-row>
        <v-row v-else-if="!activeExceptions">
          <v-col cols="12">
            <v-divider></v-divider>
            <div class="text-h6 text-center mt-3">
              Nessuna Eccezione Attiva Presente
            </div>
          </v-col>
        </v-row>
        <v-row v-else class="pl-8 pb-5">
          <v-sheet elevation="8">
            <!--
            <v-tabs
              color="info"
              v-model="locationId"
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              show-arrows
            >
              <v-tabs-slider color="info"></v-tabs-slider>
              <template class="my-3">
                <template v-for="(t,ti) in allLocations" >
                  <v-tab
                    :key=ti
                    :href="'#'+t.locationId"
                  >
                    {{t.text}}
                  </v-tab>
                  <v-tab-item :key=ti :id="t.locationId">
                    -->
                    <v-row class="my-n2 pl-5 pb-3">
                      <v-col cols="12" class="pl-3">
                        <v-sheet elevation="8">
                          <v-tabs
                            color="info"
                            elevation="8"
                            v-model="tab"
                            next-icon="mdi-arrow-right-bold-box-outline"
                            prev-icon="mdi-arrow-left-bold-box-outline"
                            show-arrows
                          >
                            <v-tabs-slider color="info"></v-tabs-slider>
                            <template v-for="d in allDays" >
                              <v-tab
                                :key=d
                                :href="'#'+d.date"
                                class="font-weight-bold"
                              >
                                {{d.date}}
                              </v-tab>
                              <v-tab-item :key=d.date :id="d.date" class="mb-1">

                                <v-row class="my-n2 pl-5 pb-3">
                                  <v-col cols="12">
                                    <v-sheet elevation="8" class="px-5 my-2">
                                      <!--
                                      <v-tabs
                                        v-model="mealId"
                                        color="info"
                                        next-icon="mdi-arrow-right-bold-box-outline"
                                        prev-icon="mdi-arrow-left-bold-box-outline"
                                        show-arrows
                                      >
                                        <v-tabs-slider color="info"></v-tabs-slider>
                                        <template v-for="(m,mi) in allMeals" >
                                          <v-tab
                                            :key=mi
                                            :href="'#'+m.mealId"
                                            class="font-weight-bold"
                                          >
                                            {{m.name}} 
                                          </v-tab>
                                          <v-tab-item :key=m :id="m.mealId" class="my-3 pl-5">
                                            -->
                                            <v-row class="ml-3">
                                              <v-col>Slot</v-col>
                                              <v-col>Coperti</v-col>
                                              <v-col>Coperti Interni</v-col>
                                              <v-col>Coperti Esterni</v-col>
                                              <v-col>Durata Slot</v-col>                                             
                                              <v-col>P1</v-col>
                                              <v-col>P2</v-col>
                                              <v-col>P3</v-col>

                                              <v-col>PMax</v-col>
                                              <v-col>Ad x 1 B</v-col>
                                              
                                              <v-col>Anticipo €</v-col>
                                              <v-col>Bonus</v-col>
                                              <v-col>SlotMessage</v-col>
                                              <v-col>C. Manuale</v-col>
                                              <v-col>Mostra Durata</v-col>
                                              <v-col>Attivo</v-col>                                              
                                            </v-row>
                                            <template v-for="(s,si) in activeExceptions.filter(s => s.date==d.date)">
                                              <v-row :key="si" class="" >
                                                <v-col >
                                                  <v-text-field
                                                    v-model="s.name"
                                                    :height="40"
                                                    name="slot"
                                                    outlined
                                                    readonly
                                                    dense
                                                    reverse
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col>
                                                  <v-text-field
                                                    @change="s.covers = $event === '' || $event === null ? null : Number($event)"
                                                    v-model.number="s.covers"
                                                    name="covers"
                                                    type="number"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    reverse
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col>
                                                  <v-text-field
                                                    @change="s.coversIndoor = $event === '' || $event === null ? null : Number($event)"
                                                    v-model.number="s.coversIndoor"
                                                    name="coversIndoor"
                                                    type="number"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    reverse
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col>
                                                  <v-text-field
                                                    @change="s.coversOutdoor = $event === '' || $event === null ? null : Number($event)"
                                                    v-model.number="s.coversOutdoor"
                                                    name="coversOutdoor"
                                                    type="number"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    reverse
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col>                                                                                                
                                                <v-col>
                                                  <v-text-field
                                                    @change="s.t1 = $event === '' || $event === null ? null : Number($event)"
                                                    v-model.number="s.t1"
                                                    name="tables1"
                                                    type="number"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    reverse
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col>
                                                  <v-text-field
                                                    @change="s.t2 = $event === '' || $event === null ? null : Number($event)"
                                                    v-model.number="s.t2"
                                                    name="tables2"
                                                    type="number"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    reverse
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col >
                                                  <v-text-field
                                                    @change="s.t3 = $event === '' || $event === null ? null : Number($event)"
                                                    v-model.number="s.t3"
                                                    name="tables3"
                                                    type="number"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    reverse
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col>
                                                  <v-select
                                                    :items="[15,30,45,60,75,90,120,135,150,165,180,195,210,225,240,255,270,285,300,315,330,345,360]"
                                                    v-model.number="s.duration"
                                                    @change="s.duration = $event === '' || $event === null ? null : Number($event)"
                                                    name="duration"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    clearable
                                                    hide-details="false"
                                                  ></v-select>                                                  
                                                </v-col>                                                                                                                                                                                    
                                                <v-col >
                                                  <v-text-field
                                                    @change="s.tMax = $event === '' || $event === null ? null : Number($event)"
                                                    v-model.number="s.tMax"
                                                    name="tablesMax"
                                                    type="number"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    reverse
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col> 
                                                <v-col>
                                                  <v-select
                                                    :items="[1,1.1,1.2,1.3,1.4,1.5,1.6,1.7,1.8,1.9,2,2.5,3.0,3.5,4,4.5,5,6,7,8,9,10]"
                                                    v-model.number="s.adultsForOneChild"
                                                    @change="s.adultsForOneChild = $event === '' || $event === null ? null : Number($event)"
                                                    name="adultsForOneChild"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    clearable
                                                    hide-details="false"
                                                  ></v-select>  
                                                </v-col>
                                                <v-col >
                                                  <v-text-field
                                                    @change="s.prepayment = $event === '' || $event === null ? null : Number($event)"
                                                    v-model.number="s.prepayment"
                                                    name="prepayment"
                                                    type="number"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    reverse
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col >
                                                  <v-text-field
                                                    v-model="s.bonus"
                                                    name="bonus"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col >
                                                  <v-text-field
                                                    v-model="s.slotMessage"
                                                    name="slotMessage"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    hide-details="false"
                                                  ></v-text-field>
                                                </v-col>                                                
                                                <v-col class="d-flex justify-center">
                                                  <v-checkbox
                                                    v-model="s.manualConfirmation"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    class="mt-0"
                                                    hide-details="false"
                                                  ></v-checkbox>
                                                </v-col>
                                                <v-col>
                                                  <v-checkbox
                                                    v-model="s.showBookingDuration"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    class="mt-0"
                                                    hide-details="false"
                                                  ></v-checkbox>
                                                </v-col>                                                 
                                                <v-col class="d-flex justify-center">
                                                  <v-checkbox
                                                    v-model="s.active"
                                                    outlined
                                                    dense
                                                    :height="40"
                                                    class="mt-0"
                                                    hide-details="false"
                                                  ></v-checkbox>
                                                </v-col>
                                              </v-row>
                                            </template>
                                          <!--
                                          </v-tab-item>
                                        </template>
                                      </v-tabs>
                                      -->
                                    </v-sheet>
                                  </v-col>
                                </v-row>
                              </v-tab-item>
                            </template>
                          </v-tabs>
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <!--
                  </v-tab-item>
                </template>
              </template>
            </v-tabs>
            -->
          </v-sheet>
        </v-row>
      </v-card>
  </div>
  <!--
  <v-dialog v-model="dialog_edit" fullscreen v-if="editedItem" transition="dialog-bottom-transition">
      <v-card>
          <v-toolbar
          >           
            <v-toolbar-title class="text-h5 mr-3">{{editedItem[0].value?'Modifica Eccezione del ':'Crea Eccezione per il '}}</v-toolbar-title>
            <v-col cols="12" md="2"> 
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="exceptionDate"
                    label="Giorno"
                    background-color="blue-grey darken-3"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="exceptionDate"
                  locale="it"
                  :first-day-of-week="1"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu> 
            </v-col>
            <v-spacer></v-spacer>

            <v-toolbar-items class="pt-2">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :loading="loading_update" :disabled="editedItem_hash==JSON.stringify(editedItem)||!exceptionDate" @click.stop="saveExceptions()">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="dialog_instruction=true">
                      <v-icon color="info">mdi-help-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="dialog_edit=false">
                      <v-icon color="info">mdi-close-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-toolbar-items>
          </v-toolbar>          
          <v-data-table
            :headers="tableHeaders"
            :items="editedItem"
            disable-pagination
            hide-default-footer
            class="elevation-1"
          >
            <template #[`item.slotName`]="{ item }">
              <v-text-field
                v-model="item.slotName"
                outlined
                dense
                readonly
                hide-details
              ></v-text-field>
            </template>
            
            <template #[`item.covers`]="{ item }">
              <v-text-field
                v-model.number="item.covers"
                @change="s.covers = $event === '' || $event === null ? null : Number($event)"
                type="number"
                outlined
                dense
                reverse
                clearable
                :height="40"
                hide-details
              ></v-text-field>
            </template>
            
            <template #[`item.duration`]="{ item }">

              <v-select
                :items="[15,30,45,60,75,90,120,135,150,165,180,195,210,225,240,255,270,285,300,315,330,345,360]"
                v-model.number="item.duration"
                @change="s.duration = $event === '' || $event === null ? null : Number($event)"
                name="duration"
                outlined
                dense
                :height="40"
                clearable
                reverse
                hide-details="false"
              ></v-select> 
            </template>

            <template #[`item.t1`]="{ item }">
              <v-text-field
                v-model.number="item.t1"
                @change="s.covers = $event === '' || $event === null ? null : Number($event)"
                type="number"
                outlined
                dense
                reverse
                clearable
                :height="40"
                hide-details
              ></v-text-field>
            </template>
            
            <template #[`item.t2`]="{ item }">
              <v-text-field
                v-model.number="item.t2"
                @change="s.t2 = $event === '' || $event === null ? null : Number($event)"
                type="number"
                outlined
                dense
                reverse
                clearable
                :height="40"
                hide-details
              ></v-text-field>
            </template>
            
            <template #[`item.t3`]="{ item }">
              <v-text-field
                v-model.number="item.t3"
                @change="s.t3 = $event === '' || $event === null ? null : Number($event)"
                type="number"
                outlined
                dense
                reverse
                clearable
                :height="40"
                hide-details
              ></v-text-field>
            </template>

            <template #[`item.tMax`]="{ item }">
              <v-text-field
                v-model.number="item.tMax"
                @change="s.tMax = $event === '' || $event === null ? null : Number($event)"
                type="number"
                outlined
                dense
                reverse
                clearable
                :height="40"
                hide-details
              ></v-text-field>
            </template>


            <template #[`item.adultsForOneChild`]="{ item }">

                <v-select
                  :items="[1,1.1,1.2,1.3,1.4,1.5,1.6,1.7,1.8,1.9,2,2.1,2.2,2.3,2.4,2.5,2.6,2.7,2.8,2.9,3]"
                  v-model.number="item.adultsForOneChild"
                  @change="s.adultsForOneChild = $event === '' || $event === null ? null : Number($event)"
                  name="adultsForOneChild"
                  outlined
                  dense
                  :height="40"
                  reverse
                  clearable
                  hide-details="false"
                ></v-select>              
            </template>

            <template #[`item.prepayment`]="{ item }">
              <v-text-field
                v-model.number="item.prepayment"
                @change="s.prepayment = $event === '' || $event === null ? null : Number($event)"
                type="number"
                outlined
                dense
                reverse
                clearable
                :height="40"
                hide-details
              ></v-text-field>
            </template>
            
            <template #[`item.bonus`]="{ item }">
              <v-text-field
                v-model="item.bonus"
                outlined
                dense
                clearable
                :height="40"
                hide-details
              ></v-text-field>
            </template>
            
            <template #[`item.manualConfirmation`]="{ item }">
              <v-checkbox
                v-model="item.manualConfirmation"
                dense
                :height="40"
                class="mt-0 d-inline-flex"
                hide-details
                @click="save2(item.manualConfirmation, 'manualConfirmation', item.slotId, $event)"
              ></v-checkbox>
            </template>
          </v-data-table>
      </v-card>
  </v-dialog> 
  --> 
  <v-dialog v-model="dialog_edit" fullscreen v-if="editedItem" transition="dialog-bottom-transition">
      <v-card>
          <v-toolbar
          >           
            <v-toolbar-title class="text-h5 mr-3">{{editedItem[0].value?'Modifica Eccezione del ':'Crea Eccezione per il '}}</v-toolbar-title>
            <v-col cols="12" md="2"> 
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="exceptionDate"
                    label="Giorno"
                    background-color="blue-grey darken-3"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="exceptionDate"
                  locale="it"
                  first-day-of-week=1
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu> 
            </v-col>
            <v-spacer></v-spacer>

            <v-toolbar-items class="pt-2">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :loading="loading_update" :disabled="editedItem_hash==JSON.stringify(editedItem)||!exceptionDate" @click.stop="saveExceptions()">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="dialog_instruction=true">
                      <v-icon color="info">mdi-help-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="dialog_edit=false">
                      <v-icon color="info">mdi-close-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-toolbar-items>
          </v-toolbar>          
          <v-row class="mx-3">
            <!--<v-col cols="12" class="d-flex justify-space-around py-3">-->
              <v-row class="justify-space-around mt-3">
                <template v-for="(h,hi) in header">
                  <v-col class="mx-0 pl-3" :key="hi">
                    <v-tooltip top >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          {{h.title}}
                        </div>
                      </template>
                      <span>{{h.description}}</span>
                    </v-tooltip>
                  </v-col>
                </template>
              </v-row>
            <!--</v-col>-->
            <template v-for="(s,si) in allSlots"> 
              <v-row  :key="si" class="justify-space-around">
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-text-field
                    v-model="editedItem[si].slotName"
                    name="slotId"
                    outlined
                    dense
                    :value="s.slotId"
                    readonly
                    reverse
                    hide-details
                  ></v-text-field>                
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-text-field
                    v-model="editedItem[si].covers"
                    name="covers"
                    type="number"
                    outlined
                    dense
                    reverse
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-text-field
                    v-model="editedItem[si].coversIndoor"
                    name="coversIndoor"
                    type="number"
                    outlined
                    dense
                    reverse
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-text-field
                    v-model="editedItem[si].coversOutdoor"
                    name="coversOutdoor"
                    type="number"
                    outlined
                    dense
                    reverse
                    hide-details
                  ></v-text-field>
                </v-col>                             
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-text-field
                    v-model="editedItem[si].t1"
                    name="t1"
                    type="number"
                    outlined
                    dense
                    reverse
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-text-field
                    v-model="editedItem[si].t2"
                    name="tables2"
                    type="number"
                    outlined
                    dense
                    reverse
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-text-field
                    v-model="editedItem[si].t3"
                    name="t3"
                    type="number"
                    outlined
                    dense
                    reverse
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model.number="editedItem.tMax"
                    @change="s.tMax = $event === '' || $event === null ? null : Number($event)"
                    type="number"
                    outlined
                    dense
                    reverse
                    clearable
                    :height="40"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-select
                    :items="[1,1.1,1.2,1.3,1.4,1.5,1.6,1.7,1.8,1.9,2,2.5,3.0,3.5,4,4.5,5,6,7,8,9,10]"
                    v-model.number="editedItem.adultsForOneChild"
                    @change="s.adultsForOneChild = $event === '' || $event === null ? null : Number($event)"
                    name="adultsForOneChild"
                    outlined
                    dense
                    :height="40"
                    reverse
                    clearable
                    hide-details="false"
                  ></v-select> 
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-select
                    :items="[15,30,45,60,75,90,120,135,150,165,180,195,210,225,240,255,270,285,300,315,330,345,360]"
                    v-model.number="editedItem[si].duration"
                    @change="editedItem[si].duration = $event === '' || $event === null ? null : Number($event)"
                    name="duration"
                    outlined
                    dense
                    :height="40"
                    clearable
                    reverse
                    hide-details="false"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-text-field
                    v-model="editedItem[si].prepayment"
                    name="prepayment"
                    type="number"
                    outlined
                    dense
                    reverse
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-text-field
                    v-model="editedItem[si].bonus"
                    name="bonus"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-text-field
                    v-model="editedItem[si].slotMessage"
                    name="slotMessage"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-checkbox
                    v-model="editedItem[si].manualConfirmation"
                    outlined
                    name="manualConfirmation"
                    dense
                    class="mt-0"
                    hide-details="false"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="1" class="mx-0 px-1 my-1">
                  <v-checkbox
                    v-model="editedItem[si].showBookingDuration"
                    outlined
                    name="showBookingDuration"
                    dense
                    class="mt-0"
                    hide-details="false"
                  ></v-checkbox>
                </v-col>                 
              </v-row>
            </template>
          </v-row>
      </v-card>
  </v-dialog>  
  <v-dialog v-model="dialog_instruction" max-width="800">
      <v-card>
          <v-card-title class="text-h5 mb-3">
            Istruzioni
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                    <v-icon color="info">mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Esci</span>
            </v-tooltip>             
          </v-card-title>
          <v-divider></v-divider>
          <v-row class="mx-5 mt-3">
              <v-col md="6" cols="12">
                  <p>
                      Per ogni Slot di ogni giorno e di ogni Posizione, è possibile impostre:
                      <ul>
                        <li>
                          Il numero massimo di Coperti prenotabili direttamente dal Cliente
                        </li>
                        <li>
                          Il numero massimo di Tavoli prenotabili direttamente dal Cliente
                        </li>
                        <li>
                          Il numero massimo di tavoli da 1, 2 e 3 Coperti prenotabili direttamente dal Cliente (richiede vengano inserite le capienze minime e massime di ogni tavolo)
                        </li>
                        <li>
                          La durata dello slot, ovvero per quanto tempo il cliente può impegnare il tavolo
                        </li>
                        <li>
                          La somma richiesta, per ogni coperto, per accettare la prenotazione - ad esempio capodanno - (richiede account PayPal)
                        </li>
                      </ul>
                  </p>
              </v-col>
              <v-col md="6" cols="12">
                  <p>
                    Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                  </p>
                  <p>
                    Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                  </p>
              </v-col>
              <v-col cols="12">
                  <p color="error">
                      <strong>Attenzione:</strong> Questi vingoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione
                  </p>
              </v-col>
          </v-row>
      </v-card>
  </v-dialog>
</div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_edit:false,
      dialog_instruction:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      allLocations:null,
      clockStep:null,
      allDays:null,
      allSlots:null,
      allMeals:null,
      dowId:null,
      menu1:null,
      exceptionDate:null,
      activeSlots:null,
      editedItem_hash:null,
      activeExceptions:null,
      activeExceptions_hash:null,
      tabs:[],
      tab:null,
      emptyEditedItem:{slotId:null,slotName:null,covers:null,coversIndoor:null,coversOutdoor:null,tables:null,t1:null,t2:null,t3:null,tMax:null,duration:null,prepayment:null,bonus:null,slotMessage:null,manualConfirmation:null,showBookingDuration:false,active:1},
      //emptyEditedItem:{slotId:null,slotName:null,covers:null,duration:null,t1:null,t2:null,t3:null,tMax:null,adultsForOneChild:null,prepayment:null,bonus:null,manualConfirmation:null},
      editedItem:null,
      header: [ 
        {title:'Slot',          description:'Slot sul quale applicare la eccezione'},
        {title:'Coperti',   description:'Max Coperti Prenotabili'},
        {title:'Coperti Int',   description:'Max Coperti Interni Prenotabili'},
        {title:'Coperti Est',   description:'Max Esterni Coperti Prenotabili'},
        //{title:'Tavoli',    description:'Max Tavoli Prenotabili'},
        {title:'1P', description:'Max Prenotazioni da 1 Coperto'},
        {title:'2P', description:'Max Prenotazioni da 2 Coperto'},
        {title:'3P', description:'Max Prenotazioni da 3 Coperto'},
        {title:'PMax', description:'Max Coperti x Prenotazione'},
        {title:'Adulti x B', description:'Adulti per 1 Bambino'},
        {title:'Durata',    description:'Durata Max Pasto (minuti)'},
        {title:'Anticipo',  description:'Versamento richiesto per accettare Prenotazione (€ per pax)'},
        {title:'Bonus',     description:'Bonus Offerto'},
        {title:'Slot m.',     description:'Messaggio nello Slot, sopra l\'orario'},
        {title:"C Manuale", description:"Conferma Manuale"},
        {title:"Durata",remarks:"Mostra la durata della prenotazione"},
      ]
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    }
  },
  methods:
  {
    addItem(f)
    {
      if (f)
      {
        this.editedItem=f
      }
      else
      {
        this.editedItem=[];
        this.allSlots.forEach(s => {
          this.emptyEditedItem.slotId = s.value
          this.emptyEditedItem.slotName=s.text;
          this.editedItem.push({...this.emptyEditedItem})
          }
          );
          this.editedItem_hash=JSON.stringify(this.editedItem)
      }
      console.log(214,f,this.editedItem)
      this.dialog_edit=true;
    },
    deleteItem(i)
    {
      this.editedItem=i;
      console.log(359,i,this.editedItem)
      this.dialog_delete=true;
    },
    async saveExceptions(a)
    {
        console.log(239,this.editedItem);
        this.loading_update=true;
        console.log(241,this.form);
        var action=a=='delete'?'deleteItem':'saveItem';
        let payload={"action":action,"table":"AllSlotsParametersExceptions","payload":{date:this.exceptionDate,slots:this.editedItem.filter(s => s.covers!= null||s.duration!= null||s.prepayment!= null||s.manualConfirmation!= null||s.showBookingDuration!=null||s.bonus!= null||s.t1!= null||s.t2!= null||s.t3!= null||s.coversOutdoor!= null||s.coversIndoor!= null)}};
        console.log(253,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        this.dialog_delete=false;
        console.log(256,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.getData()
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
    },       
    async editItems()
    {
        this.loading_update=true;
        console.log(255,this.tab);
        let payload={"action":"saveItem","table":"AllSlotsParametersExceptions","payload":{date:this.tab,slots:this.activeExceptions.filter(s => s.date==this.tab)}};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
             this.getData();
        }   
    },
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllSlotsParametersExceptions_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.loading= false;
                    this.allLocations=res.data.payloads.allLocations;
                    this.allDays=res.data.payloads.allDays;
                    this.allMeals=res.data.payloads.allMeals;
                    this.allSlots=res.data.payloads.allSlots;
                    this.activeExceptions=res.data.payloads.activeExceptions;
                    this.activeExceptions_hash=JSON.stringify(this.activeExceptions);
                    this.tabs=res.data.payloads.allLocations;
                    console.log(282,this.allSlots,this.tabs,this.activeSlots)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    }
  },
};
</script>